<template>
  <div class="min-height">
    <TableLoading v-if="institutionTypes.page === 0"/>
    <div v-else>
      <form @submit.prevent="customerAction">
        <div class="row">
          <div class="col-sm-6 mb-3">
            <label>Customer Type</label>
            <multiselect v-model="customer.typeId" :options="institutionTypes.objects" :class="{'is-invalid': v$.customer.typeId.$error}"
                         class="multiselect-height-3" placeholder="Select one" label="name" track-by="name" :searchable="true" :internal-search="false" @search-change="asyncFindCustomerType">
              <span slot="noResult">No type found. Change search query.</span>
            </multiselect>
            <p
                v-for="error in v$.customer.typeId.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-6 mb-3">
            <label>Customer Name</label>
            <input
                v-model="customer.name"
                name="name"
                type="text"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.customer.name.$error,
                      }"
            />
            <p
                v-for="error of v$.customer.name.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-4 mb-3">
            <label>Email</label>
            <input
                v-model="customer.email"
                name="name"
                type="email"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.customer.email.$error,
                      }"
            />
            <p
                v-for="error of v$.customer.email.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-4 mb-3">
            <label>Phone Number</label>
            <phone-mask-input
                v-model="customer.phoneNumber"
                autoDetectCountry
                showFlag
                wrapperClass="d-flex justify-content-between"
                inputClass="w-90 form-control py-3 "
                :class="{ 'is-invalid': v$.customer.phoneNumber.$error}"
                flagClass="flag-example align-self-center"
            />
            <p
                v-for="error of v$.customer.phoneNumber.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-4 mb-3">
            <label>KRA PIN</label>
            <input
                v-model="customer.pin"
                name="name"
                type="text"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.customer.pin.$error,
                      }"
            />
            <p
                v-for="error of v$.customer.pin.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-4 mb-3">
            <label>PO Box - Postal Code</label>
            <input
                v-model="customer.postalCode"
                name="name"
                type="text"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.customer.postalCode.$error,
                      }"
            />
            <p
                v-for="error of v$.customer.postalCode.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-4 mb-3">
            <label>Bank Name</label>
            <input
                v-model="customer.bankName"
                name="name"
                type="text"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.customer.bankName.$error,
                      }"
            />
            <p
                v-for="error of v$.customer.bankName.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-4 mb-3">
            <label>Bank Branch</label>
            <input
                v-model="customer.branch"
                name="name"
                type="text"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.customer.branch.$error,
                      }"
            />
            <p
                v-for="error of v$.customer.branch.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-4 mb-3">
            <label>Account Name</label>
            <input
                v-model="customer.accountName"
                name="name"
                type="text"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.customer.accountName.$error,
                      }"
            />
            <p
                v-for="error of v$.customer.accountName.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-4 mb-3">
            <label>Account Number</label>
            <input
                v-model="customer.accountNumber"
                name="name"
                type="number"
                class="form-control py-3"
                :class="{
                        'is-invalid': v$.customer.accountNumber.$error,
                      }"
            />
            <p
                v-for="error of v$.customer.accountNumber.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-6 mb-3">
            <label>Expected Payment Period (In Days)</label>
            <select class="form-select form-control py-3" v-model="customer.expectedPaymentPeriod"
                    :class="{
                        'is-invalid': v$.customer.expectedPaymentPeriod.$error,
                      }"
            >
              <option selected>Select One</option>
              <option :value="0">0 Days</option>
              <option :value="30">30 Days</option>
              <option :value="45">45 Days</option>
              <option :value="60">60 Days</option>
              <option :value="90">90 Days</option>
            </select>
            <small class="form-text text-muted">The number of days payment is due after maturation of an invoice, usually at the end of the month.</small>
            <p
                v-for="error of v$.customer.expectedPaymentPeriod.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div class="col-sm-6 mb-3">
            <label>Invoicing Period (In days)</label>
            <select class="form-select form-control py-3" v-model="customer.invoicingPeriod"
                    :class="{
                        'is-invalid': v$.customer.invoicingPeriod.$error,
                      }"
            >
              <option selected>Select One</option>
              <option :value="0">0 Days</option>
              <option :value="30">30 Days</option>
              <option :value="45">45 Days</option>
              <option :value="60">60 Days</option>
              <option :value="90">90 Days</option>
            </select>
            <small class="form-text text-muted">The number of days payment is due after delivery of an order.</small>
            <p
                v-for="error of v$.customer.invoicingPeriod.$errors"
                :key="error.$uid"
                class="invalid-feedback"
            >
              {{error.$message}}
            </p>
          </div>
          <div v-for="(error, index) in customerErrors" :key="index" style="color: #D13704;">
            {{error.message}}
          </div>
          <div class="mt-3 col-12">
            <b-button variant="primary" size="lg" class="py-3 h3 w-100" disabled v-if="customerLoading">
              <i class="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
              Loading
            </b-button>
            <b-button variant="primary" size="lg" class="py-3 h3 w-100 text-white" type="submit" v-else>
              {{ button_text }}
            </b-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import PhoneMaskInput from  "vue-phone-mask-input";
import Multiselect from "vue-multiselect";
import useVuelidate from "@vuelidate/core";
import {required} from "@vuelidate/validators";
import {mapGetters} from "vuex";
import {ALL_CUSTOMER_TYPES} from "@/gql";
import TableLoading from "@/components/TableLoading";

export default {
name: "customer-form",
  components: {TableLoading, Multiselect, PhoneMaskInput},
  setup () {
    return { v$: useVuelidate() }
  },
  data(){
    return{
      customer: this.selected_customer,
      typeSearchKeyword: "",
      institutionTypes: {
        page: 0,
        objects: []
      }
    }
  },
  computed: {
    ... mapGetters({
      customerLoading: 'customers/customerLoading',
      customerErrors: 'customers/customerErrors'
    }),
  },
  apollo: {
    institutionTypes: {
      query: ALL_CUSTOMER_TYPES,
      variables(){
        return {
          page: 1,
          perPage: 30,
          searchKeyword: this.typeSearchKeyword
        }
      }
    }
  },
  validations () {
    return {
      customer: {
        name: {required},
        typeId: {required},
        email: {required},
        phoneNumber: {required},
        pin: {required},
        bankName: {required},
        accountName: {required},
        accountNumber: {required},
        branch: {required},
        expectedPaymentPeriod: {required},
        invoicingPeriod: {required},
        postalCode: {required},
      }
    }
  },
  props: {
    selected_customer: {
      type: Object,
      default () {
        return {
          typeId:"",
          name:"",
          email:"",
          phoneNumber:"",
          pin:"",
          bankName:"",
          accountName:"",
          accountNumber:"",
          branch:"",
          expectedPaymentPeriod: 0,
          invoicingPeriod: 0,
          postalCode:"",
        }
      }
    },
    button_text: {type: String}
  },
  methods:{
    async customerAction() {
      const isFormCorrect = await this.v$.$validate()
      if (!isFormCorrect) {
        return
      }

      const data = {
        ...this.customer,
        typeId: this.customer.typeId.publicId,
        expectedPaymentPeriod: parseInt(this.customer.expectedPaymentPeriod),
        invoicingPeriod: parseInt(this.customer.invoicingPeriod)
      }

      this.$emit('customerAction', data)
      this.v$.$touch();
    },
    asyncFindCustomerType (query) {
      this.typeSearchKeyword = query
    }
  }
}
</script>

<style scoped>

</style>
